import React, { Component } from 'react'
import { StaticQuery, graphql } from 'gatsby'
import classNames from 'classnames'
import RichText from '~components/RichText'
import Sprite from '~components/Sprite'
import dayjs from 'dayjs'
import * as styles from '../../styles/layout/feeds.module.scss'
import * as buttonStyles from '~styles/components/button.module.scss'
import Link from '~components/Link'
const advancedFormat = require('dayjs/plugin/advancedFormat')
dayjs.extend(advancedFormat)

export default class Feeds extends Component {
  render () {
    return (
      <StaticQuery
        query={query} render={({ feed, twitter }) => (
          <div className={styles.feeds}>
            <div className="grid-container">
              <div className={classNames(styles.items, 'grid-x grid-margin-x grid-smedium-center grid-xlarge-center')}>
                {/* <section className={classNames(styles.item, 'cell smedium-9 medium-8 large-6 xlarge-5')}>
                 <span className={classNames(styles.icon, 'icon iconMd')} aria-hidden="true">
                   <Sprite name="twitterOutline" />
                 </span>

                 <h3 className={styles.title}>
                   Latest tweet
                 </h3>

                 <time dateTime="2020-09-17" className={styles.time}>
                   TODAY
                 </time>

                 <div className={styles.content}>
                   <p>
                     <blockquote class="twitter-tweet">
                       <p lang="en" dir="ltr">We have opened our new Soul &amp; Grain landside store.
                         <br /><br />
                         Serving handmade, freshly baked sourdoughs &amp; pastries, a range of locally sourced sandwiches, wraps, hot boxes, salads &amp; Barista-made Artisan coffee from <a href="https://twitter.com/extractcoffee?ref_src=twsrc%5Etfw">@extractcoffee</a> roasters.<br /><br />✈️ <a href="https://twitter.com/hashtag/FlyLCY?src=hash&amp;ref_src=twsrc%5Etfw">#FlyLCY</a> <a href="https://twitter.com/hashtag/LoveLCY?src=hash&amp;ref_src=twsrc%5Etfw">#LoveLCY</a> <a href="https://twitter.com/hashtag/FreshFood?src=hash&amp;ref_src=twsrc%5Etfw">#FreshFood</a> <a href="https://twitter.com/hashtag/ArtisanCoffee?src=hash&amp;ref_src=twsrc%5Etfw">#ArtisanCoffee</a></p>&mdash; London City Airport (@LondonCityAir) <a href="https://twitter.com/LondonCityAir/status/1693557224742834221?ref_src=twsrc%5Etfw">August 21, 2023</a></blockquote>
                     {' '}
                     <Link
                       href={`https://www.twitter.com/LCYMediaSales/status/1693557224742834221`}
                       aria-label="Read more: LCY - Media Sales tweets"
                     >
                       read more
                     </Link>
                     .
                   </p>
                 </div>

                 <div className={styles.button}>
                   <Link
                     href="https://twitter.com/LCYMediaSales"
                     aria-label="View all: LCY - Media Sales tweets"
                     className={classNames(buttonStyles.button)}
                   >
                     View all

                     <span className={classNames(buttonStyles.icon, 'icon')}>
                       <Sprite name="arrow" fill={true} />
                     </span>
                   </Link>
                 </div>
                </section> */}

                <section className={classNames(styles.item, 'cell smedium-9 medium-8 large-6 xlarge-5')}>
                  <span className={classNames(styles.icon, 'icon iconMd')} aria-hidden="true">
                    <Sprite name="speaker" />
                  </span>

                  <h3 className={styles.title}>
                    {feed.title}
                  </h3>

                  <span className={styles.time}>
                  </span>

                  {feed.text && (
                    <div className={styles.content}>
                      <RichText json={JSON.parse(feed.text.raw)} />
                    </div>
                  )}

                  <div className={styles.button}>
                    <Link
                      href={feed.link}
                      aria-label="Read more: London City Airport News"
                      className={classNames(buttonStyles.button)}
                    >
                      Read more

                      <span className={classNames(buttonStyles.icon, 'icon')}>
                        <Sprite name="arrow" fill={true} />
                      </span>
                    </Link>
                  </div>
                </section>
              </div>
            </div>
          </div>
        )}
      />
    )
  }
}

export const query = graphql`
  query {
    feed: contentfulFeed {
      title
      date
      text {
        raw
      }
      link
    }
  }
`
// ,
//     twitter: twitterStatusesUserTimelineTwittertimeline {
//       full_text
//       created_at
//       id_str
//     }
